module.exports = __webpack_public_path__ + "img/thirdd.0fc4083e.jpg";